import {
  post
} from "./https"

//首页
export const getIndex = p => post("/api/index", p);
//文章分类
export const articleCate = p => post("/api/articleCate", p);
//文章列表
export const articleList = p => post("/api/articleList", p);
//文章详情
export const articleDetails = p => post("/api/articleDetails", p);
//课程列表
export const curriculumList = p => post("/api/curriculumList", p);
//课程详情
export const curriculumDetails = p => post("/api/curriculumDetails", p);
//课程评论列表
export const curriculumCommentList = p => post("/api/curriculumCommentList", p);
//课程评论
export const curriculumComment = p => post("/api/curriculumComment", p);
//收藏课程
export const CollectionCourses = p => post("/api/CollectionCourses", p);
//咨询分类
export const consultList = p => post("/api/consultList", p);
//老师排行榜
export const teacherRanking = p => post("/api/teacherRanking", p);
//热门评价
export const popularReviews = p => post("/api/popularReviews", p);
//社区发布
export const community = p => post("/api/community", p);
//上传图片
export const uploadImg = p => post("/api/uploadImg", p);
//社区列表
export const communityList = p => post("/api/communityList", p);
//我的发布
export const myCommunity = p => post("/api/myCommunity", p);
//删除我的发布
export const delMyCommunity = p => post("/api/delMyCommunity", p);
//社区点赞
export const fabulous = p => post("/api/fabulous", p);
//社区关注
export const follow = p => post("/api/follow", p);
//社区帖子评论
export const communityComment = p => post("/api/communityComment", p);
//登录
export const login = p => post("/api/login", p);
//获取用户信息
export const user = p => post("/api/user", p);
export const getUserInfo = p => post("/api/getUserInfo", p);
//获取验证码
export const getCode = p => post("/api/getCode", p);
//完善资料
export const information = p => post("/api/information", p);
//老是列表
export const teacherList = p => post("/api/teacherList", p);
//老师筛选
export const screen = p => post("/api/screen", p);
//老师详情
export const teacherDetails = p => post("/api/teacherDetails", p);
//老师详情评论
export const teacherCommentList = p => post("/api/teacherCommentList", p);
//问答分类
export const problemCate = p => post("/api/problemCate", p);
//问题列表
export const problemList = p => post("/api/problemList", p);
//提交订单
export const order = p => post("/api/order", p);
//选择老师 
export const answersTeacher = p => post("/api/answersTeacher", p);
//成为老师
export const becomeTeacher = p => post("/api/becomeTeacher", p);
//客服/用户协议
export const pages = p => post("/api/pages", p);
//投诉反馈
export const complaint = p => post("/api/complaint", p);
//优惠券
export const couponList = p => post("/api/couponList", p);
//选择优惠券
export const coupons = p => post("/api/coupons", p);
//支付
export const pay = p => post("/api/pay", p);
//jsSdk
export const jsSdk = p => post("/api/jsSdk", p);
//我的订单
export const myOrder = p => post("/api/myOrder", p);
// 称骨算命
export const weighBone = p => post("/api/notUser/weighBone", p);
// 扑克占卜
export const poker = p => post("/api/notUser/poker", p);
// 生肖算命
export const chineseZodiac = p => post("/api/notUser/chineseZodiac", p);
// 生命灵数
export const life = p => post("/api/notUser/life", p);
// 星座列表 生肖 type1星座 2生肖
export const fortuneList = p => post("/api/notUser/fortuneList", p);
// 我的五行
export const fiveElementsInfo = p => post("/api/notUser/fiveElementsInfo", p);
//生肖运势星座运势详情
export const fortuneDetails = p => post("/api/notUser/fortuneDetails", p);
// 星座配对
export const constellationPairing = p => post("/api/notUser/constellationPairing", p);
// 生肖配对
export const chineseZodiacPair = p => post("/api/notUser/chineseZodiacPair", p);
// 号码凶吉
export const numberBadLuck = p => post("/api/notUser/numberBadLuck", p);
// 指纹吉凶
export const fingerprint = p => post("/api/notUser/fingerprint", p);
// 眼跳吉凶
export const saccade = p => post("/api/notUser/saccade", p);
// 周公解梦
export const oneiromancy = p => post("/api/notUser/oneiromancy", p);
// 常见的梦
export const oneiromancyList = p => post("/api/notUser/oneiromancyList", p);
// 血型配对
export const bloodGroupMatching = p => post("/api/notUser/bloodGroupMatching", p);
// 获取微信用户信息
export const getWxUserInfo = p => post("/api/getWxUserInfo", p);
//手机号登录绑定openID
export const TokenBindOpenid = p => post("/api/TokenBindOpenid", p);
// 取消订单
export const cancelOrder = p => post("/api/cancelOrder", p);
// 金币列表
export const goldRechargeList = p => post("/api/goldRechargeList", p);
// 金币充值
export const goldRecharge = p => post("/api/goldRecharge", p);
// 下载音频
export const downAndSaveFile = p => post("/api/downAndSaveFile", p);
// 快捷聊天语
export const shortcutsList = p => post("/api/shortcutsList", p);
// 老师问答详情
export const teacherAnswerDetails = p => post("/api/teacherAnswerDetails", p);
// 老师解答
export const teacherAnswer = p => post("/api/teacherAnswer", p);
// 用户问答详情
export const myAnswerDetails = p => post("/api/myAnswerDetails", p);
// 老师订单
export const teacherOrder = p => post("/api/teacherOrder", p);
//删除快捷聊天语
export const shortcutsDel = p => post("/api/shortcutsDel", p);
//删除快捷聊天语
export const shortcutsAdd = p => post("/api/shortcutsAdd", p);
//房间未完成订单列表
export const orderListByRoom = p => post("/api/orderListByRoom", p);
//确认订单
export const confirmOrder = p => post("/api/confirmOrder", p);
//获取评价标签
export const commentTag = p => post("/api/commentTag", p);
//订单评论
export const orderEvaluate = p => post("/api/orderEvaluate", p);
//我的收藏
export const myCollection = p => post("/api/myCollection", p);
//我的关注
export const fansList = p => post("/api/fansList", p);
//老师搜索数据获取
export const getSearche = p => post("/api/getSearche", p);
//老师搜索实时接口
export const immediateSearch = p => post("/api/immediateSearch", p);
//签到
export const signIn = p => post("/api/signIn", p);
//签到信息
export const getSignInfo = p => post("/api/getSignInfo", p);
//领取优惠券
export const receiveSignCoupon = p => post("/api/receiveSignCoupon", p);
//更改咨询问答接单状态
export const openConsultOrProblem = p => post("/api/openConsultOrProblem", p);
//老师确认订单
export const teacherConfirmOrder = p => post("/api/teacherConfirmOrder", p);
//老师发布的课程
export const teacherCurriculum = p => post("/api/teacherCurriculum", p);
//老师课程订单
export const teacherCurriculumOrder = p => post("/api/teacherCurriculumOrder", p);
//我的明细 
export const myDetailed = p => post("/api/myDetailed", p);
//体现  
export const withdrawal = p => post("/api/withdrawal", p);
//系统消息
export const systemMessage = p => post("/api/systemMessage", p);

//常见的梦
export const oneiromancyCommon = p => post("/api/notUser/oneiromancyCommon", p);
//我收到的评价
export const getMyEvaluate = p => post("/api/getMyEvaluate", p);
//获取客服roomID
export const getServiceRoomeId = p => post("/api/getServiceRoomeId", p);

//获取时间
export const otherData = p => post("/api/other", p);

//获取未读数量
export const msgNumAll = p => post("/api/msgNumAll", p);

export const msgPageNum = p => post("/api/msgPageNum", p);

//抢单列表
export const grabbingList = p => post("/api/grabbingList", p);

//抢单
export const grabbing = p => post("/api/grabbing", p);

//获取分享图片
export const extension = p => post("/api/extension", p);

//帖子详情
export const communityOne = p => post("/api/communityOne", p);

//文章评论列表 
export const articleCommentList = p => post("/api/articleCommentList", p);

//文章评论列表 
export const articleComment = p => post("/api/articleComment", p);

//文章评论点赞
export const articleCommentFabulous = p => post("/api/articleCommentFabulous", p);

//获取APPID
export const getAppid = p => post("/api/pay/getappid",p);
//获取openID
export const getOpenid = p => post("/api/pay/getopenid",p);
//获取老师信息
export const userTeacherDetail =p => post("/api/userTeacherDetail",p)

export const noticeService =p=> post("/api/noticeService",p)
export const rewardTeacher =p=>post("/api/rewardTeacher",p)
export const invitePay = p=>post("/api/invitePay",p)
export const getArticle = p=>post("/api/notUser/getArticle/index",p)


